module.exports = __webpack_public_path__ + "img/intro.c3020a27.png";